let cache = [];

function importAll(r) {
  r.keys().forEach(key => {
    console.log(r(key));
    cache = cache.concat(r(key));
  });
}

importAll(require.context('.', true, /router\.js$/));

let routes = [];
cache.forEach(r => {
  routes = routes.concat(r.default);
});

export default routes;
